import React from 'react';

interface DocumentHoldersProps {}

export function DocumentHolders(props: Readonly<DocumentHoldersProps>) {
	return (
		<svg width={97} height={90} viewBox="0 0 97 90" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
			<path d="M29.36 12.994l67.38 5.294-4.332 35.134-63.049.963v-41.39z" fill="#3E454A" />
			<path
				fill="#505A63"
				stroke="#71828F"
				d="M.761 51.167l19.493-34.453a3.5 3.5 0 012.287-1.693l6.317-1.404V32.11l-13.22 22.663L.761 51.167z"
			/>
			<path d="M28.876 14.44l-1.925.48-.963 19.252h2.888V14.44z" stroke="#505A63" />
			<path
				fill="#505A63"
				d="M44.279 36.578V14.44l-4.546 1.05a4 4 0 00-2.578 1.922L15.883 54.867l17.326 1.925 11.07-20.214z"
			/>
			<path
				stroke="#71828F"
				d="M44.279 14.44l-3.906.65a4 4 0 00-2.813 1.957l-21.677 37.82M29.36 13.477l67.38 4.812"
			/>
			<path d="M20.695 75.561l26.952-8.663V0L20.695 10.588v64.974z" fill="#CFCFCF" />
			<path d="M21.656 76.524l26.952-9.626V0L21.656 10.588v65.936z" fill="#A5A5A5" />
			<path d="M22.621 75.561l26.952-8.663V0L22.621 10.588v64.974z" fill="#CFCFCF" />
			<path d="M23.582 76.524l26.952-9.626V0L23.582 10.588v65.936z" fill="#A5A5A5" />
			<path d="M24.547 76.524l26.952-9.626V0L24.547 10.588v65.936z" fill="#CFCFCF" />
			<path
				fill="#505A63"
				d="M74.004 18.352l4.444-1.026v26.47l-8.182 17.327-18.77-1.925 19.847-38.771a4 4 0 012.661-2.075z"
			/>
			<path
				fill="#505A63"
				d="M56.857 16.56l4.746-.677v23.583L51.496 59.198l-18.289-2.406 20.699-38.178a4 4 0 012.95-2.053z"
			/>
			<path
				stroke="#71828F"
				d="M78.93 17.326l-4.893 1.049a4 4 0 00-2.714 2.07L51.496 58.718M61.606 15.883l-4.723.675a4 4 0 00-2.969 2.086L33.691 56.792"
			/>
			<path d="M57.273 84.707l26.952-14.92V2.89L57.273 13.477v71.23z" fill="#CFCFCF" />
			<path d="M58.234 84.707l26.952-14.92V2.89L58.234 13.477v71.23z" fill="#A5A5A5" />
			<path d="M59.2 84.707l26.951-14.92V2.89L59.2 13.477v71.23z" fill="#CFCFCF" />
			<path d="M60.16 84.707l26.952-14.92V2.89L60.16 13.477v71.23z" fill="#A5A5A5" />
			<path d="M61.121 84.707l26.952-14.92V2.89L61.121 13.477v71.23z" fill="#CFCFCF" />
			<path d="M0 77.006V51.498l70.267 9.625L90.481 18.29h6.257L94.813 74.6 70.267 90 0 77.006z" fill="#71828F" />
			<path d="M0 77.006V51.498l70.267 9.626V90L0 77.006z" fill="#000" fillOpacity={0.1} />
			<path d="M.48 51.016l70.75 10.107" stroke="#71828F" />
		</svg>
	);
}
